import {
  GET_MATCH_CARD_TRIBUN_COUPONS_REQUEST,
  GET_MATCH_CARD_TRIBUN_COUPONS_SUCCESS,
  GET_MATCH_CARD_TRIBUN_COUPONS_FAILURE,
  GET_MATCH_CARD_TRIBUN_COUPONS_LOADMORE_SUCCESS,
  SET_MATCHCARD_LAST_FEEDS,

  RESET_MATCH_CARD,

  SEND_COMMENT_SUCCESS,

  SHOW_OR_HIDE_COUOPON_REQUEST,
  SHOW_OR_HIDE_COUOPON_SUCCESS,

  LIKE_OR_UNLIKE_COUPON_SUCCESS,
  COMMENT_FORBID_ALLOW_SUCCESS,

  FOLLOW_TRIBUN_USER_REQUEST,
  FOLLOW_TRIBUN_USER_SUCCESS,
  FOLLOW_TRIBUN_USER_FAILURE,
} from 'Store/constants';
import { commentForbiddenStoreStateChanger, shareOrHideStoreStateChanger } from 'Utils/tribunStoreHelpers';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_TRIBUN_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_MATCH_CARD_TRIBUN_COUPONS_LOADMORE_SUCCESS:
      return { ...state, data: [...state.data, ...action.payload], isLoading: false, error: null };
    case GET_MATCH_CARD_TRIBUN_COUPONS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case SET_MATCHCARD_LAST_FEEDS:
      return { ...state, lastMatchCardFeeds: action.payload, error: null };
    case GET_MATCH_CARD_TRIBUN_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case RESET_MATCH_CARD:
      return { ...initialState };

    case SEND_COMMENT_SUCCESS:
      return {
        ...state,
        data: state.data.map(item => ({
          ...item,
          comments: item.feedId === action.payload.comment.feedId
            ? item.comments + 1 : item.comments,
        }))
      };

    case LIKE_OR_UNLIKE_COUPON_SUCCESS:
      return {
        ...state,
        data: state.data.map(item => {
          if (item.feedId === action.feedId) {
            return {
              ...item,
              likes: action.isLiked ? item.likes + 1 : item.likes - 1,
              liked: action.isLiked,
            };
          } else {
            return item;
          }
        })
      };
    case COMMENT_FORBID_ALLOW_SUCCESS:
    {
      if (action.tabType === 'match-card') {
        state = commentForbiddenStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case SHOW_OR_HIDE_COUOPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SHOW_OR_HIDE_COUOPON_SUCCESS:
    {
      if (action.tabType === 'match-card') {
        state = shareOrHideStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case FOLLOW_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FOLLOW_TRIBUN_USER_SUCCESS:
    {
      if (action.tabType === 'match-card') {
        state.data.map(item => {
          if (action.userId === item.user.userId) {
            item.user.following = !item.user.following;
            item.user.following ? ++item.user.stats.followers : --item.user.stats.followers;
          }
        });
      }
      return { ...state, isLoading: false, error: null };
    }
    case FOLLOW_TRIBUN_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
};